import _ from "lodash";
import { Available } from "../../gateway/Available/Available";
import { CalculatingMachineV2Gateway } from "../../gateway/CalculatingMachineV2Gateway/CalculatingMachineV2Gateway";
import { DashboardAvailable } from "../../gateway/DashboardAvailable/DashboardAvailable";
import { Point } from "../../gateway/Point/Point";
import { Serie } from "../../gateway/Serie/Serie";
import { getFullYear } from "../../utils/date/date";
import { AvailablePeriod } from "../services/AvailablePeriod/AvailablePeriod";
import { CompanyDataAvailable } from "../services/CompanyDataAvailable/CompanyDataAvailable";
import { DashboardsViewService } from "../services/DashboardsView/DashboardsViewService";
import { PopulateManager } from "../services/PopulateManager/PopulateManager";
// Serivço tem como principal objetivo centralizar logicas de população de dados em um so lugar
export class DataManagerService {
    constructor() {
        this.Available = new Available();

        this.AvailablePeriod = new AvailablePeriod();

        this.CompanyDataAvailable = new CompanyDataAvailable();

        this.DashboardAvailable = new DashboardAvailable({
            CompanyDataAvailable: this.CompanyDataAvailable,
            Available: this.Available
        });

        this.PopulateManager = new PopulateManager();

        this.Point = new Point({
            PopulateManager: this.PopulateManager
        });

        this.Serie = new Serie({
            PopulateManager: this.PopulateManager
        });

        this.DashboardsViewService = new DashboardsViewService({
            AvailableHttpGateway: this.Available,
            CompanyDataAvailableHttpGateway: this.CompanyDataAvailable,
            DashboardAvailableHttpGateway: this.DashboardAvailable
        });

        this.CalculatingMachineV2Gateway = new CalculatingMachineV2Gateway();
    }

    /**
     * @param{ source, dashboardId } pegamos o source e verificamos se ele e um sub source de outroa fonte de dados
     * @returns {string} source disponivel
     */
    getAvailableSource({ source, dashboardId, companyId }) {
        return this.DashboardsViewService.getValidateSource({
            source,
            dashboardId,
            companyId,
            currentSource: source
        });
    }

    /**
     *
     * @param {Object} {year: number}
     * @returns {Array} {years: number}
     */
    getYearsAvailableToPopulate({
        companyId,
        periodName,
        dateBase,
        dateCompare,
        scenarioIdBase,
        source,
        yearsList = []
    }) {
        if (yearsList.length > 0) {
            return yearsList;
        }

        let years = [];

        if (periodName == "monthly") {
            years = [getFullYear(dateBase), getFullYear(dateBase) - 1];

            if (dateCompare) years.push(dateCompare.getUTCFullYear());

            years = _.uniq(years);
        } else {
            years = this.Available.getYears(companyId, source, scenarioIdBase);
        }

        return years;
    }

    async managerPointsCalc({
        company,
        source,
        dashboardId,
        scenarioIdBase,
        scenarioIdCompare,
        periodName,
        analyzeGroup,
        allMonths,
        multipleSource = false,
        currentDate,
        startDate,
        currentComparation,
        projection,
        projectionCompare,
        budget,
        availableFilter,
        goals,
        goalsIds,
        visualization,
        isShowtime = false,
        allMonthsByYear = false
    }) {
        const sourceValidated = this.getAvailableSource({
            source,
            dashboardId,
            companyId: company._id
        });

        if (goals) {
            await this.CalculatingMachineV2Gateway.calculateSeries({
                companyData: company,
                source: sourceValidated,
                scenarioId: scenarioIdBase,
                analyzeGroup,
                analysisPeriod: periodName,
                multipleSource,
                currentDate,
                startDate,
                currentComparation,
                projection,
                budget,
                availableFilter,
                goals,
                goalsIds,
                dashboardId
            });
            return true;
        }
        let seriesIds = [];
        // if (visualization && !isShowtime) {
        //     seriesIds = [...visualization.series, visualization?.mainSerieId];
        //     if (Array.isArray(visualization?.highlightsSeriesIds)) {
        //         seriesIds.push(...visualization?.highlightsSeriesIds);
        //     } else {
        //         seriesIds.push(visualization?.highlightsSeriesIds);
        //     }
        // }
        if (isShowtime) dashboardId = undefined;

        await this.CalculatingMachineV2Gateway.calculateSeries({
            companyData: company,
            source: sourceValidated,
            seriesIds,
            scenarioId: scenarioIdBase,
            analyzeGroup,
            analysisPeriod: periodName,
            multipleSource,
            currentDate,
            startDate,
            currentComparation,
            projection,
            budget,
            availableFilter,
            dashboardId,
            allMonthsByYear
        });

        if (
            (scenarioIdCompare && scenarioIdCompare != scenarioIdBase) ||
            (projectionCompare && projectionCompare != projection)
        ) {
            await this.CalculatingMachineV2Gateway.calculateSeries({
                companyData: company,
                source: sourceValidated,
                scenarioId: scenarioIdCompare,
                analyzeGroup,
                seriesIds,
                analysisPeriod: periodName,
                multipleSource,
                currentDate,
                startDate,
                currentComparation,
                dashboardId,
                projection: projectionCompare
            });
        }

        if (budget) {
            await this.CalculatingMachineV2Gateway.calculateSeries({
                companyData: company,
                source: sourceValidated,
                scenarioId: budget,
                analyzeGroup,
                seriesIds,
                analysisPeriod: periodName,
                multipleSource,
                currentDate,
                startDate,
                currentComparation,
                dashboardId
            });
        }

        if (allMonths) {
            await this.CalculatingMachineV2Gateway.calculateSeries({
                companyData: company,
                source: sourceValidated,
                scenarioId: scenarioIdBase,
                analyzeGroup,
                seriesIds,
                analysisPeriod: periodName,
                multipleSource,
                currentDate,
                currentComparation,
                dashboardId
            });
        }
    }
}
